import {PIXI} from '@colonist/pixi'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {UIGameManager} from '../UIGameManager'
import {MovingSpriteView} from '../../ui_canvas_engine/MovingSpriteView'
import {UIGameMapEdgeController} from './UIGameMapEdgeController'
import {TileEdge, isCornerBuildingKnight, Point} from '@colonist/game-mechanic-validators'
import {TileEdgeDirection} from '@colonist/game-states'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {ToolTipText} from 'code/client/web/scripts/ui_game/ui_game_tooltip/UIWGameToolTipController'

// Oct 25, 2020 Jeff. This file was just copied from MapRoadView to quickly add a visual for the ship
// during development. This file will likely need heavy editing.

export class UIGameMapShipView {
    private readonly uiGameManager: UIGameManager

    private readonly shipPosition: Point
    private readonly view: MovingSpriteView
    private readonly shipHighlight: SpriteView
    edge: TileEdge

    constructor(uiGameManaer: UIGameManager, edge: TileEdge, container: PIXI.Container, drawingExistingEdges: boolean) {
        if(edge.owner == undefined) return

        this.uiGameManager = uiGameManaer
        const mapView = this.uiGameManager.mapController.mapView
        const hexHeight = mapView.hexagonHeight
        this.edge = edge
        const shipTexture = UIGameSpriteHandler.getShipForPlayer(edge.owner, edge.hexEdge.z)
        const height = hexHeight / 2
        const width = hexHeight / 2
        const edgeCenter = edge.hexEdge.centerPointToPixel(mapView.mapCenter, hexHeight / 2)
        this.shipPosition = new Point(edgeCenter.x - width / 2, edgeCenter.y - height / 2)
        const animationYPoint = drawingExistingEdges ? this.shipPosition.y : this.shipPosition.y - hexHeight
        const animationStartP1 = new Point(this.shipPosition.x, animationYPoint)

        const aspectRatio = shipTexture.width / shipTexture.height
        const viewHeight = height / 2 * 1.15
        const viewWidth = aspectRatio * viewHeight
        this.view = new MovingSpriteView(animationStartP1.x, animationStartP1.y, viewWidth, viewHeight, container, shipTexture)

        const shipScaling = this.getShipScaling()
        this.view.width *= shipScaling
        this.view.height *= shipScaling

        this.setShipPosition(edge.hexEdge.z)

        const shipHighlightTexture = UIGameSpriteHandler.getShipHighlight(edge.hexEdge.z)
        const scalingToSeeHighlight = this.getShipHighlightScaling()

        const shipHighlighWidht = viewWidth * scalingToSeeHighlight
        const shipHighlightHeight = shipHighlightTexture.height / shipHighlightTexture.width * shipHighlighWidht

        const xScalingOffset = (viewWidth - shipHighlighWidht) / 2
        const yScalingOffset = (viewHeight - shipHighlightHeight) / 2

        this.shipHighlight = new SpriteView(this.shipPosition.x + xScalingOffset, this.shipPosition.y + yScalingOffset, shipHighlighWidht, shipHighlightHeight, container, shipHighlightTexture)
        this.shipHighlight.width *= shipScaling
        this.shipHighlight.height *= shipScaling
        this.deactivateHighlight()

        this.setLayer()
    }

    private setShipPosition(edgeVariable: TileEdgeDirection) {
        switch(edgeVariable) {
            case TileEdgeDirection.NorthWest:
                this.shipPosition.x += this.view.width * 0.5
                this.shipPosition.y += this.view.height * 0.15
                break
            case TileEdgeDirection.West:
                this.shipPosition.x += this.view.width * 0.78
                this.shipPosition.y += this.view.height * 0.38
                break
            case TileEdgeDirection.SouthWest:
                this.shipPosition.x += this.view.width * 0.55
                this.shipPosition.y += this.view.height * 0.17
                break
        }
    }

    private getShipScaling(): number {
        if(this.edge.hexEdge.z == TileEdgeDirection.West) return 0.95

        return 1
    }

    private getShipHighlightScaling(): number {
        if(this.edge.hexEdge.z == TileEdgeDirection.West) return 1.12

        return 1.08
    }

    executeStartAnimation(edge: TileEdge, drawingExistingEdges: boolean, pointerover: (event) => void, pointerout: (event) => void, toolTipText: ToolTipText) {
        const animationCallback = drawingExistingEdges ? () => {
            this.view.setHoverAction(pointerover, pointerout)
            this.view.setTip({key: 'strings:colonistCommon.utils.emptyString'}, [], toolTipText)
        } : () => {
            UIGameMapEdgeController.playEdgeSound(edge)
            this.view.setHoverAction(pointerover, pointerout)
            this.view.setTip({key: 'strings:colonistCommon.utils.emptyString'}, [], toolTipText)
        }

        this.view.animationController.animationCompleteCallBack = animationCallback
        this.view.animationController.animateTo(this.shipPosition)
    }

    removeView() {
        if(this.view.parent == undefined) return
        this.view.parent.removeChild(this.view)
        if(this.shipHighlight.parent != undefined) this.shipHighlight.parent.removeChild(this.shipHighlight)
    }

    private isShipPlacedOnWestEdgeAndBelowCornerBuilding(): boolean {
        if(this.edge.hexEdge.z != TileEdgeDirection.West) return false
        for(const hexCorner of this.edge.hexEdge.endPoints()) {
            if(hexCorner.y >= this.edge.hexEdge.y) continue

            const tileCorner = this.uiGameManager.gameState.mapState.tileState.getTileCorner(hexCorner)
            if(tileCorner == undefined) continue

            if(isCornerBuildingKnight(tileCorner.buildingType)) continue

            if(tileCorner.owner != undefined) return true
        }
        return false
    }

    activateHighlight() {
        this.shipHighlight.visible = true
    }

    deactivateHighlight() {
        this.shipHighlight.visible = false
    }

    setLayer(offset: number = 0) {
        const shipLayer = this.getShipLayer()
        this.view.zIndex = shipLayer + offset
        this.shipHighlight.zIndex = shipLayer - 0.05 + offset
    }

    private getShipLayer(): number {
        const defaultShipLayer = this.uiGameManager.mapController.mapView.layers.mapEdgePieces
        const halfALayer = 0.5
        const layerAboveCornerBuildings = this.uiGameManager.mapController.mapView.layers.mapCornerPieces + halfALayer
        return this.isShipPlacedOnWestEdgeAndBelowCornerBuilding() ? layerAboveCornerBuildings : defaultShipLayer
    }
}
